export const enum VIEWS {
	HOMEPAGE = 'Homepage',
	COLLECTION = 'TemplatesCollectionView',
	EXECUTIONS = 'Executions',
	EXECUTION_PREVIEW = 'ExecutionPreview',
	EXECUTION_DEBUG = 'ExecutionDebug',
	EXECUTION_HOME = 'ExecutionsLandingPage',
	TEMPLATE = 'TemplatesWorkflowView',
	TEMPLATE_SETUP = 'TemplatesWorkflowSetupView',
	TEMPLATES = 'TemplatesSearchView',
	CREDENTIALS = 'CredentialsView',
	NEW_WORKFLOW = 'NodeViewNew',
	WORKFLOW = 'NodeViewExisting',
	DEMO = 'WorkflowDemo',
	DEMO_DIFF = 'WorkflowDemoDiff',
	TEMPLATE_IMPORT = 'WorkflowTemplate',
	WORKFLOW_ONBOARDING = 'WorkflowOnboarding',
	SIGNIN = 'SigninView',
	SIGNUP = 'SignupView',
	SIGNOUT = 'SignoutView',
	SETUP = 'SetupView',
	FORGOT_PASSWORD = 'ForgotMyPasswordView',
	CHANGE_PASSWORD = 'ChangePasswordView',
	SETTINGS = 'Settings',
	USERS_SETTINGS = 'UsersSettings',
	LDAP_SETTINGS = 'LdapSettings',
	PERSONAL_SETTINGS = 'PersonalSettings',
	SECURITY_SETTINGS = 'SecuritySettings',
	API_SETTINGS = 'APISettings',
	NOT_FOUND = 'NotFoundView',
	COMMUNITY_NODES = 'CommunityNodes',
	WORKFLOWS = 'WorkflowsView',
	WORKFLOW_EXECUTIONS = 'WorkflowExecutions',
	EVALUATION = 'Evaluation',
	EVALUATION_EDIT = 'EvaluationEdit',
	EVALUATION_RUNS_DETAIL = 'EvaluationRunsDetail',
	USAGE = 'Usage',
	LOG_STREAMING_SETTINGS = 'LogStreamingSettingsView',
	SSO_SETTINGS = 'SSoSettings',
	EXTERNAL_SECRETS_SETTINGS = 'ExternalSecretsSettings',
	SAML_ONBOARDING = 'SamlOnboarding',
	SOURCE_CONTROL = 'SourceControl',
	MFA_VIEW = 'MfaView',
	WORKFLOW_HISTORY = 'WorkflowHistory',
	WORKER_VIEW = 'WorkerView',
	PROJECTS = 'Projects',
	PROJECT_DETAILS = 'ProjectDetails',
	PROJECTS_WORKFLOWS = 'ProjectsWorkflows',
	PROJECTS_CREDENTIALS = 'ProjectsCredentials',
	PROJECT_SETTINGS = 'ProjectSettings',
	PROJECTS_EXECUTIONS = 'ProjectsExecutions',
	PROJECT_ROLES_SETTINGS = 'ProjectRolesSettingsView',
	PROJECT_ROLE_SETTINGS = 'ProjectRoleSettingsView',
	PROJECT_NEW_ROLE = 'ProjectNewRoleView',
	PROJECT_ROLE_VIEW = 'ProjectRoleViewView',
	PROJECTS_VARIABLES = 'ProjectsVariables',
	HOME_VARIABLES = 'HomeVariables',
	FOLDERS = 'Folders',
	PROJECTS_FOLDERS = 'ProjectsFolders',
	INSIGHTS = 'Insights',
	SHARED_WITH_ME = 'SharedWithMe',
	SHARED_WORKFLOWS = 'SharedWorkflows',
	SHARED_CREDENTIALS = 'SharedCredentials',
	ENTITY_NOT_FOUND = 'EntityNotFound',
	ENTITY_UNAUTHORIZED = 'EntityUnAuthorized',
	PRE_BUILT_AGENT_TEMPLATES = 'PreBuiltAgentTemplates',
	AI_SETTINGS = 'AISettingsView',
	OAUTH_CONSENT = 'OAuthConsent',
	MIGRATION_REPORT = 'MigrationReport',
	MIGRATION_RULE_REPORT = 'MigrationRuleReport',
	RESOLVERS = 'Resolvers',
	RESOURCE_CENTER = 'ResourceCenter',
	RESOURCE_CENTER_SECTION = 'ResourceCenterSection',
}

export const EDITABLE_CANVAS_VIEWS = [VIEWS.WORKFLOW, VIEWS.NEW_WORKFLOW, VIEWS.EXECUTION_DEBUG];

export const enum MAIN_HEADER_TABS {
	WORKFLOW = 'workflow',
	EXECUTIONS = 'executions',
	SETTINGS = 'settings',
	EVALUATION = 'evaluation',
}
